import React from 'react';
import './SetupInsights.css'

const insights = [
  { label: 'Area Required', value: '300–400 sqft' },
  { label: 'Franchise Fees', value: '₹2.5 Lakhs' },
  { label: 'Average Revenue', value: '₹3–5 Lakhs / month' },
  { label: 'Average Profit', value: '₹1–2.5 Lakhs / month' },
  { label: 'Net Profit', value: '30–45%' },
  { label: 'Break Even', value: '18–20 months' },
  { label: 'Royalty', value: '5% on gross sales after ₹1 Lakh' },
];

export default function SetupInsights() {
  return (
    <section className="setup-insights">
      <h2 className="insights-title">Setup Insights & Pricing</h2>
      <div className="insights-grid">
        {insights.map((item, idx) => (
          <div key={idx} className="insight-card">
            <h4>{item.label}</h4>
            <p>{item.value}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
